import { SelectInput, SelectInputProps, useTranslate } from 'react-admin';
import { InputLabel } from '@mui/material';

export const GraySelectInputWithUpperLabel = (props: SelectInputProps) => {

  const translate = useTranslate();

  return (
    <>
      {props.label !== false && (
        <InputLabel className="input-label">
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <SelectInput
        {...props}
        label={false}
        inputProps={{
          ...props.inputProps,
          style: {
            backgroundColor: '#f1f1f1',
            borderRadius: '5px',
            ...props.inputProps?.style,
          },
        }}
        sx={{
          mt: 0,
          mb: 0,
          ...props.sx,
          '& fieldset': {
            border: 'none',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f1f1 !important',
            boxSizing: 'border-box',
            minHeight: 40,
            height: 40,
            alignItems: 'center',
          },
        }}
      />
    </>
  );

};
